import { Link } from "react-router-dom";
import { Check, X as XIcon, Sparkles } from "lucide-react";

const GENERIC_AI = [
  "Requires complex prompts",
  "Generic responses",
  "No CV writing methodology",
  "General-purpose writing",
  "No UK career focus",
];

const CV_FOLKS_AI = [
  "Built by Professional UK CV Writers",
  "Guided step-by-step workflow",
  "Recruiter-informed methodology",
  "ATS-friendly structure",
  "Built specifically for the UK job market",
  "Professional templates",
  "Career-focused guidance",
];

/** "Why Pay £9.99?" — addresses the biggest objection head-on with a
 *  Generic AI vs CV Folks AI comparison. */
export default function AiComparison() {
  return (
    <section
      data-testid="ai-comparison-section"
      className="py-20 md:py-28"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <p className="label-eyebrow">Why pay £9.99?</p>
          <h2 className="font-serif text-3xl md:text-5xl font-bold mt-3 leading-[1.05]">
            Free AI can write text.{" "}
            <span className="text-brand">It can&apos;t write a professional UK CV.</span>
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground/70">
            Generic AI tools give you words. CV Folks AI gives you a
            professional CV writing process — built by experienced UK CV
            writers and designed for the UK job market.
          </p>
        </div>

        <div
          data-testid="ai-comparison-table"
          className="grid md:grid-cols-2 gap-5"
        >
          {/* Generic AI */}
          <div className="rounded-3xl border border-border bg-muted/40 p-6 md:p-8">
            <p className="label-eyebrow">Generic AI Tools</p>
            <p className="text-xs text-muted-foreground mt-1">
              ChatGPT, free CV generators, general chatbots
            </p>
            <ul className="mt-6 space-y-3.5">
              {GENERIC_AI.map((row) => (
                <li
                  key={row}
                  data-testid={`comparison-generic-${row.toLowerCase().replace(/\s+/g, "-")}`}
                  className="flex items-start gap-3 text-sm text-foreground/70"
                >
                  <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-neutral-200 text-neutral-500 shrink-0">
                    <XIcon className="h-3.5 w-3.5" strokeWidth={3} />
                  </span>
                  <span className="pt-0.5">{row}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* CV Folks AI */}
          <div className="relative rounded-3xl border-2 border-brand/40 bg-card p-6 md:p-8 shadow-xl shadow-brand/10">
            <span className="absolute -top-3.5 left-6 inline-flex items-center gap-1.5 rounded-full bg-brand text-white text-[11px] font-bold uppercase tracking-wider px-3 py-1.5 shadow">
              <Sparkles className="h-3 w-3" /> £9.99 — one-time
            </span>
            <p className="label-eyebrow text-brand">CV Folks AI</p>
            <p className="text-xs text-muted-foreground mt-1">
              A professional CV writing process, powered by AI
            </p>
            <ul className="mt-6 space-y-3.5">
              {CV_FOLKS_AI.map((row) => (
                <li
                  key={row}
                  data-testid={`comparison-cvfolks-${row.toLowerCase().replace(/\s+/g, "-")}`}
                  className="flex items-start gap-3 text-sm font-medium"
                >
                  <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-emerald-100 text-emerald-700 shrink-0">
                    <Check className="h-3.5 w-3.5" strokeWidth={3} />
                  </span>
                  <span className="pt-0.5">{row}</span>
                </li>
              ))}
            </ul>
            <Link
              to="/ai-cv-builder"
              data-testid="comparison-cta"
              className="btn-primary mt-7 w-full inline-flex items-center justify-center gap-2 rounded-full px-6 py-3.5 text-sm font-semibold"
            >
              <Sparkles className="h-4 w-4" /> Build My CV — £9.99
            </Link>
          </div>
        </div>

        <p className="text-center text-xs text-muted-foreground mt-6">
          Every comparison is factual — we won&apos;t make claims about competitors we can&apos;t back up.
        </p>
      </div>
    </section>
  );
}
